import i18n from "@/plugins/i18n";
import moment from "moment";
import logoBoson from "@/assets/LogoBosonWhite.png";
import avatar from "@/assets/avatar-btn.png";

export default {
  NeutrinoUrl: "https://ws-neutrino-dvp.azurewebsites.net/api/v2/",
  //NeutrinoUrl: "https://apprgps.tresguerras.com.mx/ws/utrax/neutrino/api/v2/",
  //WebServerOwner: "TG", 
  WebServerOwner: "BOSON",
  // apiKeyGoogle:
  //   "https://maps.googleapis.com/maps/api/js?client=gme-autotransportesde",
  connectionID: "",
  carrierId: "",
  // carrierId: "712ba872-1467-4aaf-b8a5-cbb19f704954",
  //Define si aparecen ciertos componentes que no son de desarrollo, hasta que esten listos para produccion
  production: true,
  permissions: true,
  initialSettings: false,
  //style global
  globalStyle:
    "margin-top: 10px;   will-change: padding !important; padding: 103px 0px 0px 80px !important;",
  appDrawerStyle: "z-index: 9; position: fixed;transform: translateX(0px);",
  fontsizecard: "",
  fontsizesub: "",
  styleFV: "",
  whitesmoke: "",
  paddingLeftSecondaryT: "",
  ///SECONDARY TOOLBAR CALENDAR
  maxDate: "",
  minDate: "",
  periodDatesTitle: "",
  periodDatesTitleAF: "",
  datesCalendar: [],
  datesBetween: [],
  startClock: "12:00",
  endClock: "11:59",
  //LOGIN COMPONENT
  authenticated: false,
  remember: false,
  invalidUser: false,
  progresslogin: false,
  imageLogo: logoBoson,
  loginBtn: "",
  styleLogo: "margin: 0px; width: 25rem;",
  padding: "padding: 2%;",
  styleMargin: "margin: 5px;",
  styleListOfAccess:
    "max-height: 67%;overflow-y: scroll;height: 357px;max-width: 100%;display: inline-block;",
  worldVisible: true,
  //Token auth
  token: "",
  //All info of token
  tokenInfo: "",
  //Token for refresh new token
  refreshToken: "",
  //for snackbar
  snackbar: false,
  selected: [],
  selectedVal: [],
  numberpages: 0,
  y: "top",
  x: null,
  mode: "",
  timeout: 3000,
  text: "",
  x: 0,
  y: 0,
  //Vue validation form
  valid: true,
  tokenRules: [],
  emailRules: [],
  username: "",
  password: "",
  //All list of access
  UserAccessList: [],
  //Only selected access
  SelectedAccess: [],
  //All data of user
  userData: [],
  serviceListAlertFuelIn: false,
  serviceListAlertTruck: false,
  //Selected filter acccess
  SelectedUserAccess: [],
  //All list of access
  multipleUserData: [],
  data: "",
  multipleAccess: false,
  search: "",
  setLocale: "enMX",
  //Table of multiple access
  headers: [],
  datitos: [],
  error: null,
  //REPORTS PAGE COMPONENT
  searchReport: "",
  selectedReports: [],
  selectedReport: [],
  headersReports: [],
  reportList: [],
  Reports: [],
  progress: false,
  progressFilter: false,
  //DASHBOARD PAGE
  ItemsDashboard: [],
  itemsAwait: false,
  titleAwait: "",

  //Alertruck vehicles information
  headersAlertruckVehiclesInfo: [],
  itemsAlertruckVehiclesInfo: [],
  progressAlertruckVehiclesInfo: false,

  //ACCOUNTBALANCEPAGE
  ItemsAccountBalancePage: [],
  //CHARTS DASHBOARD
  ChartsOptions: {},
  PieChartOptions: {},
  fuelUsed: {},
  RalentiFuel: {},
  FuelRange: {},
  FuelLowRange: {},
  EngineOn: {},
  MoreTimeEngineOn: {},
  Exceptions: {},
  MoreExceptions: {},
  chartsArray: [],
  //CHARTS ACCOUNT BALANCE PAGE
  ChartStackedOptiones: {},
  TotalFuel: {},
  FuelWeek: {},
  EngineOnTime: {},
  EngineOnWeek: {},
  Distance: {},
  DistanceWeek: {},
  Rendimiento: {},
  RendimientoSemanal: {},
  //CHARTS VEHICLES EXCEPTIONS
  ChartVehiclesExceptions: {},
  speedExcess: {},
  brusqueAccelerations: {},
  brakedBrusque: {},
  excessMotoLoad: {},
  excessRPM: {},
  clutchExcesses: {},
  roundBrushes: {},
  excessEngineHours: {},
  motorVacuumExceeces: {},
  //APP DRAWER COMPONENT
  itemsMenu: [],
  mini: true,
  itemsOptions: [],
  itemsOptionsTraffic: [],
  active: false,
  bottomSheet: false,
  persistent: true,
  userImage: avatar,
  //NEW REPORT COMPONENT (STEPPER, REPORT DETAILS, FILTER VEHICLES, SUMMARY)
  //STEPPER COMPONET
  styleComponent: "",
  hiddeFilterV: false,
  hiddeDetails: true,
  hiddeSummary: true,
  toContinue: false,
  colorStep2: "#c6c6c6",
  colorStep3: "#c6c6c6",
  valueDeterminate: 100,
  e1: 0,
  finish: false,
  showMessage: true,
  errorMessage: false,
  errorMessageText: "",
  //FILTER VEHICLES
  DealerId: "",
  headersFilterV: [],
  dealersDisabled: false,
  clientsDisabled: false,
  accountsDisabled: false,
  groupsDisabled: false,
  dealerSelected: {},
  clientSelected: {},
  accountSelected: {},
  groupSelected: {},
  all: "",
  vehicles: [],
  dealers: [],
  clients: [],
  accounts: [],
  groups: [],
  noResults: "",
  disableFV: true,
  vehiclesListItems: [],
  headerFVTable: [],
  dealerAttach: false,
  clientAttach: false,
  accountAttach: false,
  groupAttach: false,
  //SUMMARY
  overlayCard: true,
  //REPORT DETAILS PAGE
  Columns: [],
  Columns2: [],
  ItemsColums: [],
  NameOfReport: "",
  Emails: [],
  VehiclesCount: "",
  VehiclesList: [],
  PeriodOfReportTitle: "",
  startDateReport: "",
  endDateReport: "",
  startDate: "",
  endDate: "",
  startTime: {},
  endTime: {},
  startTimeH: "",
  endTimeH: "",
  PeriodReport: [],
  TypeOfReport: i18n.t("PerformanceReport"),
  SelectedColumns: [],
  Minutes: [],
  Hours: [],
  ampm: ["AM", "PM"],
  all: true,
  //SECONDARY TOOLBAR
  titleToolbar: "ALERTRUCK",
  PageHeader: "",
  PageHeaderSub: "",
  PageHeaderSub1: "",
  PageHeaderSub2: "",
  refreshOnHeader: true,
  visible: true,
  navIconSecondaryT: "",
  //Online or Offline
  LastUserDate: "",
  sessionexp: false,
  //AccountManager
  headersSecureU: [],
  secureUsers: [],
  headersDealers: [],
  dealersList: [],
  // Styles of Dashboard
  fontSizechart: "",
  itemDistanceFuelRange: 0,
  itemDistanceExceptions: 0,
  alignchart: "",
  xchart: "",
  //Settings
  colorTheme: "#8FAE2D",
  progressColor: "#424242",
  settings: false,
  swicth: false,
  SelectedDistance: "Km",
  SelectedVolume: "L",
  SelectedTemperature: "°C",
  distance: "",
  volume: "",
  temperature: "",
  Distance: ["Km", "mi"],
  Volumen: ["L", "gal"],
  Temperature: ["°C", "°F"],
  nextWizzard: false,
  //Skeleton
  skeleton: "",
  skeletonTitle: "",
  skeletonPie: "",
  skeletonFooter: "",
  skeletonColumn: "",
  viewSkeletons: true,

  itemsDashboardCharts: [],
  itemsExceptionsCharts: [],
  itemsBalanceCharts: [],
  backgroundSkeleton: "background: #e0e0e0;",
  infoChartExceptions: false,
  settingsTitle: "",
  //Personalization component
  styleColorPicker: "padding: 7px; margin-left: 12px;",
  styleTab: "",
  colorPickerWidth: "",

  //items Charts
  chartsDashboard: [
    "fuelUsed",
    "RalentiFuel",
    "FuelRange",
    "FuelLowRange",
    "EngineOn",
    "MoreTimeEngineOn",
    "Exceptions",
    "MoreExceptions",
  ],
  chartsAcountBalance: [
    "TotalFuel",
    "FuelWeek",
    "EngineOnTime",
    "EngineOnWeek",
    "Distance",
    "DistanceWeek",
    "Rendimiento",
    "RendimientoSemanal",
  ],
  chartsvehiclesExceptions: [
    "speedExcess",
    "brusqueAccelerations",
    "brakedBrusque",
    "excessMotoLoad",
    "excessRPM",
    "clutchExcesses",
    "roundBrushes",
    "excessEngineHours",
    "motorVacuumExceeces",
  ],
  personalization: {
    Media: {
      UserAvatar: "ND",
      MainLogo: "ND",
    },
    Language: "ES-MX",
    Theme: {
      DarkMode: false,
      //va sin el gato
      PrimaryColor: "8FAE2D",
    },
    SU: {
      Distance: "Km",
      Volume: "L",
      Temperature: "C",
    },
    Account: {
      DealerId: "ND",
      ClientId: "ND",
      AccountId: "ND",
      GroupId: "ND",
    },
  },
  calendarTime: false,
  loginOffline: false,
  vehiclesAggregates: [],
  vistaRapida: false,
  checkFastList: false,
  Allreports: [],
  disableButton: false,
  //vinculaciones
  //opcionesvinc: [i18n.t("all"), i18n.t("entail"), i18n.t("noEntail")],
  filterVin: i18n.t("all"),
  headersOperatorsDetails: [],
  headersOperators: [],
  allOperators: [],
  listOperators: [],
  listOperatorsWithoutP: [],
  progressOp: false,
  progressMovil: false,
  listMovil: [],
  headersMovil: [],
  allMobiles: [],
  headersMobilesDetails: [],
  //Trafico
  trafficList: [],
  ChartTraffic: {},
  Trafficdetails: {},
  optionsTraffic: [
    i18n.t("allStates"),
    i18n.t("inTravel"),
    i18n.t("noTrip"),
    i18n.t("stopped"),
    i18n.t("outOfService"),
  ],
  filterTraffic: i18n.t("allStates"),
  statusTraffic: [],
  headersTraffic: [],
  hiddeAddTravel: true,
  hiddeEditTravel: false,
  startDateTravel: "",
  endDateTravel: "",
  startDate2: "",
  endDate2: "",
  startTime2: {},
  endTime2: {},
  startTimeH2: "",
  endTimeH2: "",
  editTravel: {},
  errorMaps: false,
  vehiclesCarrier: [],
  enaEndDateT: false,
  //Carriers
  allCarriers: [],
  listCarriers: [],
  headersCarriers: [],
  progressCa: false,
  listServiceType: [
    { Id: 0, Name: i18n.t("unknown") },
    { Id: 1, Name: i18n.t("cargoGeneral") },
    { Id: 2, Name: i18n.t("hazardousMaterials") },
    { Id: 3, Name: i18n.t("alimentaryGrade") },
  ],
  listModality: [
    { Id: 0, Name: i18n.t("unknown") },
    { Id: 1, Name: i18n.t("consolidated") },
    { Id: 2, Name: i18n.t("fullCar") },
  ],
  contactMediaType: [
    { Id: 0, Name: i18n.t("other") },
    { Id: 1, Name: i18n.t("phone") },
    { Id: 2, Name: "Email" },
  ],
  editCarrier: {},
  addTrip: null,
  UpdatePosition: [],
  progressOver: false,
  viewSkeletonsT: true,
  skeletonTitleT: "",
  skeletonColumnT: "",
  //DETALLE DE GRAFICAS Y TABLA
  titleGraphic: "",
  headersMetrics: [],
  PageHeaderGraphTitle: "",
  PerformanceFleet: [],
  progressDetails: false,
  cursorPointer: false,
  headersMetricsNoAction: [],
  shortByTable: "",
  //DETALLE DEFICIENCIAS
  sizeChart1: "width: 100%;height:400px;",
  sizeChart2: "width: 100%;height:400px;",
  showDashboard: false,
  start: false,
  //INDIVIDUAL PERFORMANCE
  itemsTravelEfficiencyCharts: [],
  testing: [],
  headersPerformance: [],
  headersPerformanceExcel: [],
  itemsTableInTransit: [],
  itemsTableInTransit2: [],
  ItemsPerformance: [],
  viewSkeletonsP: true,
  skeletonP: "",
  skeletonTitleP: "",
  skeletonColumnP: "",
  skeletonPieP: "",
  skeletonFooterP: "",
  listOfTrips: [],
  dataPerformance: {},
  btnDisableds: "",
  btnDisabled: false,
  coor: [],
  finalOdometer: "0",
  finalFuel: "0",
  itemsPerformanceInfo: {},
  mapDataInfo: false,
  insideMap: "",
  listOfMarkersPC: [],
  markerClusterPC: [],
  intervalStart: "",
  intervalEnd: "",
  //COMPARATIVE
  headersGlobalCalculations: [],
  itemsGlobalCalc: [],
  headersTripsAnalysis: [],
  itemsTripsAnalysis: [],
  numberOfTrips: 0,
  viewSkeletonsC: true,
  skeletonC: "",
  skeletonTitleC: "",
  skeletonColumnC: "",
  skeletonPieC: "",
  skeletonFooterC: "",
  progressC: false,
  //Individual fuel
  itemsSettings: [],
  listVehiclesAF: [],
  viewSkeletonsFP: true,
  skeletonColumnFP: "",
  viewSkeletonsAR: true,
  skeletonLineAR: "",
  viewSkeletonsRL: true,
  skeletonRL: "",
  skeletonColumnRL: "",
  itemsRetrieveLevel: {},
  itemsPerformanceAF: {},
  loaderFuel: false,
  locationRG: "",
  needRG: [],
  fullAddress: [],
  updateBtn: "",
  cardTitleIF: "",
  footerPropsAlertfuel: "",
  vehicleSelectedAF: "",
  nickFromVehSelectedAF: "",
  movilIdFromVehSelectedAF: "",
  // disableBtnAFSM: false,
  //add
  lastLevel: "",
  dateLastLevel: "",
  addressLastLevel: "",
  lat1: "",
  lon1: "",
  performanceAF: "",
  date1WS: "",
  date2WS: "",
  dataFuel: [],
  loaderSeeMore: false,
  //rastreo
  styleCardTracking: "",
  trackingTable: 5,
  trackingList: [],
  insideTrackingMap: "",
  loadingTableInTracking: false,
  listOfMarkersInTracking: [],
  markerClusterTracking: [],
  trackingMovilId: "",
  backButton: "",
  commandAndRepButton: "",
  footerProps: "",
  lastBounds: "",
  selectedVehLatLng: {},
  theCenter: "",
  selectedVeh: {},
  savePolyline: "",
  activityList: [],
  showVehTable: "",
  listOfMarkersPolyline: [],
  styleText:
    "flex-grow: 1; padding: 20px; overflow: auto; padding-top: 10px; overflow-y: scroll; max-height: calc(100vh - 750px);min-height: calc(100vh - 751px);font-size: 13px;text-align: initial;",
  // startMarker: [],
  // endMarker: [],
  startEndMarkerP: [],
  clusterforPolyline: [],
  showMsgT: false,
  titleCommand: "Confirmed command",
  failedCommand: false,
  periodTracking: "",
  reportViewVisible: false,
  statusViewVisible: false,
  commandsList: [],
  dataActivitySave: [],
  fleetLastPositionSave: [],
  responseTexto: "",
  responseText: "",
  refGeo: [],
  connectionVeh: [],
  inAndOutVeh: [],
  vehicleData: [],
  topData: [],
  indeterminateReport: false,
  clientName: "",
  dealerName: "",
  initialReport: true,
  noActivity: false,
  showTxtOp: true,
  trackingChange: false,
  listCallCommand: [],
  referencePoint: "",
  circleTracking: null,
  referencePointMarker: "",
  vehiclesInRadius: [],
  markersInRadius: [],
  trackingFirstTime: false,
  overlayToolBox: null,
  radiusActive: false,
  autocomplete: [],
  //VEHICLES AT
  vehiclesAT: [],
  loadingTableInVehAT: false,
  showVehiclesAT: true,
  optionsGroup: [],
  //TEMPLATES AT
  templatesAT: [],
  loadingTableInTemplatesAT: false,
  headersTemplatesAT: [],
  fullVersion: true,
  showTemplates: true,
  
  //NEW/EDIT TEMPLATE
  Template: {
    Name: "",
    PeriodicReports: {
      OdometerReport: false,
      FuelReport: false,
      VehicleStoppedReport: {
        Active: false,
        Threshold: ""
      },
      VehicleInMotionReport: {
        Active: false,
        hreshold: ""
      },
      TimeReport: {
        Active: false,
        Threshold: ""
      }
    },
    Logistics: {
      HighIdlePercentage: "",
      ExcessIdleTime: "",
      InsufficientRestTime: "",
      RestDetected: ""
    },
    Driving: {
      RPMExcess: {
        Active: false,
        Threshold: ""
      },
      QuickShutdown: "",
      ClutchTimeExcessStopped: "",
      ClutchTimeExcessWhileDriving: "",
      ExcessBrakeTime: "",
      SuddenAcceleration: "",
      SuddenBraking: "",
      MediumSpeeding: "",
      SevereSpeeding: ""
    },
    Operation: {
      MotorLoadExcess: {
        Active: false,
        Threshold: ""
      },
      LowCruiseControlPercentage: "",
      LowFuelEconomy: "",
      PTOStopped: {
        Active: false,
        Threshold: ""
      },
      HighAverageMotorLoad: "",
      StartOfPTOInMotion: "",
      EndOfPTOInMotion: ""
    }

  },

  //VERIFY CONFIG
  contentVehAT: [],
  comparedItems: [],
  loadingComparativeTable: false,
  selectedVehAT: "",
  //CONFIGURATION PROGRESS
  contentConfig: [],
  loadingTableInConfigProgress: false,
  //NOTIFICATIONS
  notiDrawer: false,
  client: "",
  notiArray: [],
  notiNumber: 0,
  received: [],
  logs: [],
};
